<template>
  <div class="dates">
    <!-- <p>Restrictions: {{ this.valgtHotel.restrictions }}</p> -->
    <!-- <p>Restriktion timer: {{ this.valgtHotel.restrictions.tidligst_timer }}</p> -->
    <!-- <p>Valgt Hotel: {{ this.valgtHotel }}</p> -->
    <!-- <p v-if="this.valgtHotel.restrictions !== (null, undefined) && loaded == 1">Restriktion dage: {{ this.valgtHotel.restrictions.tidligst_dage }}</p> -->
    <!-- <p>Restriktion dage: {{ this.restriction_dage }}</p> -->
    <!-- <p>bookingInProgress: {{ this.$store.getters.bookingInProgress }}</p> -->
    <!-- <p>Dates: {{ this.dates }}</p> -->
    <!-- <p>Postnr: {{ this.hotelPostnr }}</p> -->
    <!-- <p>endDate: {{ this.endDate }}</p> -->
    <!-- <p>earliestDate: {{ this.earliestDate }}</p> -->
    <!-- <p>lookupPerDate {{ this.lookupPerDate }}</p> -->
    
    <!-- Vis måneden for den dato der er 4 dage frem ift. 'lookupDate', hvis andet år end nuværende, så vis også årstal -->
    <h1 class="header">
      <!-- Måned-tilbage pil -->
      <span v-if="moment.utc(lookupPerDate).format('YYYY-MM-DD') !== moment.utc().format('YYYY-MM-DD')">
        <i class="arrow-small left" v-on:click="daysBack(30, 7);"></i>
      </span>
      <span v-else>
        <i class="arrow-small left disabled" v-on:click="daysBack(30, 7)"></i>
      </span>

      <!-- Valgte måned -->
      <span class="month">
        <span v-if="moment.utc(lookupPerDate).format('MMMM') === moment.utc(lookupPerDate).add(7, 'days').format('MMMM')">{{moment.utc(lookupPerDate).add(4, 'days').format('MMMM')}}</span>
        <span v-else>{{ moment.utc(lookupPerDate).format('MMMM') }} - {{ moment.utc(lookupPerDate).add(7, 'days').format('MMMM') }}</span>

        <!-- Hvis vi er scrollet til næste år, så vis også årstal -->
        <span v-if="moment.utc(lookupPerDate).add(4, 'days').format('YYYY') !== moment.utc().format('YYYY')">
          {{moment.utc(lookupPerDate).add(4, 'days').format('YYYY')}}
        </span>
      </span>

        <!-- Måned-fremad pil -->
        <i class="arrow-small right" v-on:click="daysForward(30, 7)"></i>
    </h1>

    <!-- Kalender for bredde mere end 960 px (Tablet, PC) -->
    <div class="flex-container" v-if="width > 959">

      <span v-if="moment.utc(lookupPerDate).format('YYYY-MM-DD') !== moment.utc().format('YYYY-MM-DD')"><i class="arrow left" v-on:click="daysBack(7, 7)"></i></span>
      <span v-else><i class="arrow left disabled" v-on:click="daysBack(7, 7)"></i></span>

      <div v-for="(date, index) in this.dates" v-bind:key="date.id" class="dateButton" v-on:click="vaelgDato(date.date, date.disabled)">

        <!-- Hvis vi ikke vælger slutdato, skal første dag vises med speciel CSS (anden farve) -->
        <p v-if="index === 0 && endDate!=1" class="dateButtonTextHeaderToday" v-html="date.dayName">{{date.dayName}}</p>
        <p v-else class="dateButtonTextHeader" v-html="date.dayName">{{date.dayName}}</p>
        
        <p class="dateButtonTextContent">{{date.dayNr}}</p>

        <!-- Vis rødt kryds hvis date er disabled -->
        <p v-if="date.disabled === 1" class="cross">&#10060;</p>
        <p v-if="date.disabled === 1 && date.reason === 'minDage' " class="disabledReason">{{ $t(date.reason, {antal_dage: date.antal_dage})}}</p>
        <p v-if="date.disabled === 1 && date.reason === 'helePerioden' " class="disabledReason">{{ $t(date.reason, {startdato: date.startDato, slutdato: date.slutDato})}}</p>
        <p v-if="date.disabled === 1 && (date.reason !== 'minDage' && date.reason !== 'helePerioden') " class="disabledReason">{{ $t(date.reason)}}</p>

      </div>
      <i class="arrow right" v-on:click="daysForward(7, 7)"></i>
    </div>

    <!-- Kalender for bredde under 960 px (Mobil) -->
    <div class="mobile" v-if="width <= 959">

    <!-- Venstre kolonne -->
    <div class="c-left">
      <span v-if="moment.utc(lookupPerDate).format('YYYY-MM-DD') !== moment.utc().format('YYYY-MM-DD')"><i class="arrow left" v-on:click="daysBack(7, 7)"></i></span>
      <span v-else><i class="arrow left disabled" v-on:click="daysBack(7, 7)"></i></span>
    </div>

    <!-- Midterkolonne -->
    <div class="c-middle">
      <div class="flex-container">
        <div v-for="(date, index) in this.dates" v-bind:key="date.id" class="dateButton" v-on:click="vaelgDato(date.date, date.disabled)">

          <!-- Hvis vi ikke vælger slutdato, skal første dag vises med speciel CSS (anden farve) -->
          <p v-if="index === 0 && endDate!=1" class="dateButtonTextHeaderToday" v-html="date.dayName">{{date.dayName}}</p>
          <p v-else class="dateButtonTextHeader" v-html="date.dayName">{{date.dayName}}</p>

          <p class="dateButtonTextContent">{{date.dayNr}}</p>

          <!-- Vis rødt kryds hvis date er disabled -->
          <p v-if="date.disabled === 1" class="cross">&#10060;</p>
          <p v-if="date.disabled === 1 && date.reason === 'minDage' " class="disabledReason">{{ $t(date.reason, {antal_dage: date.antal_dage})}}</p>
          <p v-if="date.disabled === 1 && date.reason === 'helePerioden' " class="disabledReason">{{ $t(date.reason, {startdato: date.startDato, slutdato: date.slutDato})}}</p>
          <p v-if="date.disabled === 1 && (date.reason !== 'minDage' && date.reason !== 'helePerioden') " class="disabledReason">{{ $t(date.reason)}}</p>

          

        </div>
      </div>
    </div>

    <!-- Højre kolonne -->
    <div class="c-right">
      <i class="arrow right" v-on:click="daysForward(7, 7)"></i>
    </div>
    </div>
    
    <!-- <p>Locale: {{ locale }}</p> -->
    <!-- <p>Valgt dato: {{this.valgtDato}}</p> -->
    <!-- <p>Tidligste dato: {{this.earliestDate}}</p> -->
    <!-- <p>Hotel: {{ hotelPostnr }}</p> -->
  </div>
</template>

<script>
import i18n from '@/plugins/i18n';
var moment = require('moment');

export default {
  data() {
    return {
      locale: i18n.locale,
      name: 'datePicker',
      lookupPerDate: moment.utc(this.earliestDate).format('YYYY-MM-DD'),  // Det er denne dato opslag tager udgangspunkt i, når vi bladrer i datoer o.l.
      dates: [],
      valgtDato: '',
      valgtHotel: {'restrictions': null}, // Vi definerer 'restrictions' så vi ikke får en fejl når vi prøver at læse den i template før den er loaded, eller hvis den er tom
      restriction_dage: 0,
      width: window.innerWidth,
      loaded: 0
    }
  },
  props: [
    'hotelPostnr',
    'earliestDate',
    'endDate'
    ],
  mounted() {
    moment.locale(this.locale);
    window.onresize = () => {
      this.width = window.innerWidth;
    }
    this.findDateRange(this.earliestDate, 7);
    console.log('findDateRange():' + JSON.stringify(this.dates));

    // Hent hoteldata for det hotel der er givet med som prop
    this.findHotel(this.hotelPostnr);

    // Hent restrictions for hotellet
    //this.getRestrictions(this.$route.params.koncern, this.hotelPostnr, this.lookupPerDate, moment(this.lookupPerDate).add(7, 'days').format('YYYY-MM-DD'), this.endDate);
    this.getRestrictions(this.$route.params.koncern, this.hotelPostnr, this.lookupPerDate, moment(this.lookupPerDate).add(70, 'days').format('YYYY-MM-DD'), this.endDate);
  },
  watch: {
    // Hvis 'valgtHotel' ændres (laves af this.findHotel() ), skal vi genberegne restrictions
    /*
    valgtHotel: function(val) {
      console.log('kører watcher efter valgt hotel...');
      this.restriction_dage = val.restrictions.tidligst_dage;
      this.restrictionTidligstDage(this.restriction_dage, this.endDate);
    },
    dates: function() {
      console.log('kører watcher efter ændring af dato...');
      this.restrictionTidligstDage(this.restriction_dage, this.endDate);
    },
    // Hvis 'lookupPerDate' ændres (første dato i rækken), skal vi genberegne restrictions
    lookupPerDate: function(val) {
      console.log('kører watcher efter ændring af dato...');
      this.restriction_dage = val.restrictions.tidligst_dage;
      this.restrictionTidligstDage(this.restriction_dage, this.endDate);
    }
    */
  },
  methods: {
    // Find dato-data for startdato + 'days' dage, giver YYYY-MM-DD, dag (nr) og månedsnavn for hver dato
    findDateRange(start, days) {
      if(moment.utc(start).isValid()) {
        start = moment.utc(start).startOf('day'); // Hvis der er angivet en startdato, så brug den
      } else {
        start = moment.utc().startOf('day');      // hvis ikke, så brug dags-dato
      }
      var end = moment.utc(start).add(days, 'days').startOf('day');
      var i = 0;
      this.dates = []; // Slet dates så vi kun får de nyligt genererede datoer med
      
      while (start.isBefore(end)) {
        if (start.isSame(moment.utc().startOf('day'), 'day')) {
          this.dates.push({'id': i, 'dayName': this.$i18n.t('idag'), 'dayNr': moment.utc(start).format('D'), 'date': moment.utc(start).format('YYYY-MM-DD'), 'disabled': 0});  
        } else {
          this.dates.push({'id': i, 'dayName': moment.utc(start).format('dddd'), 'dayNr': moment.utc(start).format('D'), 'date': moment.utc(start).format('YYYY-MM-DD'), 'disabled': 0});
        }
        
        start.add(1, 'days');
        i++;
      }
    },
    // Funktionalitet til 'frem' knappen i datoslideren
    daysForward(days, number) {
      this.lookupPerDate = moment.utc(this.lookupPerDate).add(days, 'days').format('YYYY-MM-DD'); // Sæt ny lookupDate 'days' frem
      this.findDateRange(this.lookupPerDate, number);                                                     // Generér de mellemliggende datoer
      //this.dates = this.dates.slice(0,7);
      this.dates.length = number; // For at være sikker på at vi ikke har mere end 'days' vi viser
      console.log('daysForward():' + JSON.stringify(this.dates));

      // Når vi ændrer visning af datoer - så hent også nye restrictions for perioden
      this.getRestrictions(this.$route.params.koncern, this.hotelPostnr, moment.utc(this.lookupPerDate).format('YYYY-MM-DD'), moment.utc(this.lookupPerDate).add(7, 'days').format('YYYY-MM-DD'), this.endDate);


    },
    // Funktionalitet til 'tilbage' knappen i datoslideren
    daysBack(days, number) {
      if(moment.utc(moment.utc(this.lookupPerDate).subtract(days-1, 'days').format('YYYY-MM-DD')).isBefore() || moment.utc(moment.utc(this.lookupPerDate).subtract(days-1, 'days').format('YYYY-MM-DD')).isBefore(this.earliestDate)) {
        // Dato er i fortiden eller tidligere end 'earliestDate' - lad være med at gå længere tilbage
      } else {
        this.lookupPerDate = moment.utc(this.lookupPerDate).subtract(days, 'days').format('YYYY-MM-DD');  // Sæt ny lookupDate 'days' tilbage
        this.findDateRange(this.lookupPerDate, number);                                                           // Generér de mellemliggende datoer
      }
      this.dates.length = number; // For at være sikker på at vi ikke har mere end 'days' vi viser
      console.log(JSON.stringify(this.dates));

      // Når vi ændrer visning af datoer - så hent også nye restrictions for perioden
      this.getRestrictions(this.$route.params.koncern, this.hotelPostnr, moment.utc(this.lookupPerDate).format('YYYY-MM-DD'), moment.utc(this.lookupPerDate).add(7, 'days').format('YYYY-MM-DD'), this.endDate);
    },

    vaelgDato(dato, disabled) {
      // Vælg kun hvis disabled ikke er sat
      if(disabled !== 1) {
        this.valgtDato = dato;
        this.sendMessageToParent();
      }
    },

    sendMessageToParent() {
      this.$emit('valgtDato', this.valgtDato);
    },

    // Hent data for det valgte hotel fra vuex store
    async findHotel(postnr) {
      //console.log('Finder data for hotel i postnr: '+postnr+' Hotels:');
      for (let i=0; i< this.$store.getters.hotels.length; i++) {
        if(this.$store.getters.hotels[i].postnr == postnr) {
          this.valgtHotel = this.$store.getters.hotels[i];
          //console.log('Fundet: '+JSON.stringify(this.valgtHotel));
        }
      }
    },

    /**
     * Disabler $dage-antal tidligste dage
     * Anvendes til f.eks. at disable muligheden for at booke de første 2 dage
     * så 'i dag' og 'i morgen' ikke kan vælges i kalenderen
     * Sætter ikke restrictions på hvis der bliver valgt afrejsedag.
     */
    restrictionTidligstDage(dage, endDate) {
     if((this.dates[0].dayName === "I DAG" || this.dates[0].dayName === "idag" || this.dates[0].dayName === "TODAY" || this.dates[0].dayName === this.$i18n.t('idag')) && endDate !== 1) { // Hvis "navnet" for første dag er "I DAG" så er kalenderen scrollet hen på dags dato og vi kan disable de første dage
     console.log('Vi har detected at i dag er aktiv i datovælgeren.');
       for(var i=0; i<dage; i++ ) {
         var objIndex = this.dates.findIndex((obj => obj.id == i));
         this.dates[objIndex].disabled = 1
         this.dates[objIndex].reason = "tidligstDage";
       }
     } else {
      console.log('Vi kan ikke se dags dato i datovælgeren, kan derfor heller ikke sætte restriction på første dage.');
     }

      console.log('Efter restrictions dates: '+JSON.stringify(this.dates));
    },
    /**
     * Ingen ankomst på denne dato
     */
    restrictionIngenAnkomst(dato, endDate) {
      this.dates.forEach(function (date) {
        if(date.date === dato && endDate != 1) {
          console.log('INGEN ANKOMST '+dato);
          date.disabled = 1;
          date.reason = "ingenAnkomst";
        }
      })
    },
    /**
     * Ingen afrejse denne dato
     */
    restrictionIngenAfrejse(dato, endDate) {
      this.dates.forEach(function (date) {
        if(date.date === dato && endDate == 1) {
          console.log('INGEN AFREJSE '+dato);
          date.disabled = 1;
          date.reason = "ingenAfrejse";
        }
      })
    },
    /**
     * Der skal bookes min x antal dage
     */
    restrictionMinDage(bookingStartdate, restriction, endDate) {
      var startdato = restriction.startdato;
      var slutdato  = restriction.slutdato;
      var antal_dage = restriction.value;
      bookingStartdate = moment.utc(bookingStartdate)
      var restrictionStartdate = moment.utc(startdato)
      var min_dage = 0;

      this.dates.forEach(function () {
        // Restriktionen skal kun gælde hvis der er valgt en startdato på bookingen der er indenfor restriktionens datointerval
        if(endDate == 1) {
          min_dage = (antal_dage-1);
          // Beregn antal dage fra første overnatning til hvor intervallet for restriktionen starter, 
          // og læg disse dage til antallet af dage vi behandler nedenfor
          var foerRestriktion = restrictionStartdate.diff(bookingStartdate, 'days')
          if(foerRestriktion > 0) {
            min_dage = foerRestriktion+(antal_dage-1)
          }

          console.log('MIN '+min_dage+' DAGE SKAL BOOKES I DENNE PERIODE'+' Startdate: '+bookingStartdate.format('YYYY-MM-DD')+' foerRestriktion: '+foerRestriktion);
        }
      })

      // vi disabler de første 'antal_dage'-dage, der er indenfor restriction intervallet
      if(min_dage > 0) {
          for(var i=0; i<min_dage; i++ ) {
            var objIndex = this.dates.findIndex((obj => obj.id == i));

            // find ud af om date er indenfor restriction intervallet
            var compareDate = moment.utc(this.dates[objIndex].date);
            if(compareDate.isBetween(startdato, slutdato, 'days', '[)')) {
              // Denne dato er indenfor restriction, og disables derfor
              this.dates[objIndex].disabled = 1
              this.dates[objIndex].reason = "minDage";
              this.dates[objIndex].antal_dage = antal_dage;
            }
          }
      }
      console.log('Restriction min_dage, antal dage: '+antal_dage+' startdato: '+startdato+' slutdato: '+slutdato+' min_dage: '+min_dage+' endDate: '+endDate);
    },
    /**
     * Hele denne periode skal bookes hvis der vælges en dato indenfor intervallet for denne restriktion
     * 
     * Hvis denne restriction bliver triggered, skal :
     * - kun første dato kunne vælges som ankomstdato
     * - kun sidste dato kunne vælges som afrejsedato
     */
    restrictionHelePerioden(restriction) {
      var startdato = moment.utc(restriction.startdato);
      var slutdato  = moment.utc(restriction.slutdato);

      // Loop igennem alle datoer i den datovælger der er fremme
      this.dates.forEach(function (date) {
        // Lav en moment instans for den dato vi er nået til i loopet
        var compareDate = moment.utc(date.date);

        // Hvis den dato vi er nået til ligger indenfor datointervallet for restriktionen
        if(compareDate.isBetween(startdato, slutdato, 'days', '[]')) {
          //console.log('HELE PERIODEN '+ startdato.format('DD-MM-YYYY') +' til '+ slutdato.format('DD-MM-YYYY') +' SKAL BOOKES');

          // Alle andre datoer, end startdatoen og slutdatoen i restriktionen disables
          if((compareDate.format('DD-MM-YYYY') != startdato.format('DD-MM-YYYY')) && (compareDate.format('DD-MM-YYYY') != slutdato.format('DD-MM-YYYY'))) {
            date.disabled = 1
            date.reason = "helePerioden";
            date.startDato = restriction.startdato;
            date.slutDato = restriction.slutdato;
          }
        }
      })
      //console.log('Restriction hele_perioden, startdato: '+startdato.format('DD-MM-YYYY')+' slutdato: '+slutdato.format('DD-MM-YYYY')+' koden skal gøre noget der får perioden til at skulle bestilles samlet');
    },


    getRestrictions(koncern, postnr, start, end, endDate) {
      var payload = {}
      payload.koncern = koncern
      payload.postnr = postnr
      payload.start = start
      payload.end = end
      // lav Vuex-kald, og vent på svaret
      this.$store.dispatch("getRestrictions", payload).then( () => {
        console.log('getRestrictions(): koncern: '+koncern+', postnr: '+postnr+' start: '+start+' end: '+end+' endDate?:'+endDate);
        console.log('Restrictions i perioden: '+JSON.stringify(this.$store.getters.restrictions));

        // forEach restriction:
        for (var restriction in this.$store.getters.restrictions) {
          if(this.$store.getters.restrictions.hasOwnProperty(restriction)) {
            //console.log('Restriction for hver dag: '+JSON.stringify(restriction)+' value: '+JSON.stringify(this.$store.getters.restrictions[restriction]));
            for(var res_name in this.$store.getters.restrictions[restriction]) {
            
              console.log('Restriction for ' + restriction + ' : '+this.$store.getters.restrictions[restriction][res_name].description+', value: '+this.$store.getters.restrictions[restriction][res_name].value)

              // hvis restriction 'ingen_ankomst' er sat, så kør restriction-filteret for 'ingen_ankomst'
              if(res_name == 'ingen_ankomst') {
                this.restrictionIngenAnkomst(restriction, this.endDate)
              }

              // hvis restriction 'ingen_afrejse' er sat, så kør restriction-filteret for 'ingen_afrejse'
              if(this.$store.getters.restrictions[restriction][res_name].description === 'ingen_afrejse') {
                this.restrictionIngenAfrejse(restriction, this.endDate)
              }
              // hvis restriction 'min_dage' er sat, så kør restriction-filteret for 'min_dage'
              if(this.$store.getters.restrictions[restriction][res_name].description === 'min_dage') {
                console.log('Restriction min_dage - kalder restrictionMinDage()');
                if(this.endDate == 1) {
                  this.restrictionMinDage(this.$store.getters.bookingInProgress.startdate, this.$store.getters.restrictions[restriction][res_name], this.endDate)
                } else {
                  this.restrictionMinDage('0000-00-00' ,this.$store.getters.restrictions[restriction][res_name], this.endDate)
                }
              }

              // hvis restriction 'hele_perioden' er sat, så kør restriction-filteret for 'hele_perioden'
              if(this.$store.getters.restrictions[restriction][res_name].description === 'hele_perioden') {
                console.log('Restriction hele_perioden - kalder restrictionHelePerioden()');
                this.restrictionHelePerioden(this.$store.getters.restrictions[restriction][res_name])
              }

              // hvis restriction 'tidligst_dage' er sat, så kør restriction-filteret for 'tidligst_dage'
              if(this.$store.getters.restrictions[restriction][res_name].description === 'tidligst_dage') {
                console.log('Restriction tidligst_dage - kalder restrictionTidligstDage()');
                this.restrictionTidligstDage(this.$store.getters.restrictions[restriction][res_name].value, this.endDate)
              }
            }


          }
        }
      })


      // TODO: outputtet fra getRestrictions Vuex-store-kaldet skal parses, og der skal genereres et nyt this.dates-array så datoerne bliver 'restricted' i UIet
    }


  }
}
</script>


<style scoped>
.flex-container {
  padding: 0;
  margin: 0;
  list-style: none;
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  flex-direction: row;
}

.flex-item {
  padding: 10px;
  width: 330px;
  height: 150px;
  margin-top: 10px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.dateButton {
  /*display: flex; */
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0px;
  -webkit-box-shadow: 0px 4px 4px #666666;
  -moz-box-shadow: 0px 4px 4px #666666;
  box-shadow: 0px 10px 10px #666666;
  color: #000000;
  background-color: rgba(239,244,251,.77);
  width: 100px;
  height: 100px;
  box-sizing: border-box;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: 1px;
  align-items: center;
  justify-content: center;
  padding: 20px 10px 10px 10px;
  margin-top: 10px;
  margin-left: 10px;
  margin-right: 10px;
  margin-bottom: 20px;
  text-align: center;
  cursor: pointer;
  position: relative;
}

.dateButton:hover {
  background-color: rgba(255,255,255,0.95);
  text-decoration: none;
  text-transform: uppercase;
}

.dateButtonTextHeaderToday {
  font-size: 90%;
  font-weight: bold;
  color: #57A00E;
}

.dateButtonTextHeader {
  font-size: 90%;
}

.dateButtonTextContent {
  font-size: 215%;
  margin: 0px;
}

.disabledReason {
  font-size: 50%;
  color: red;
  background-color: rgba(239,244,251,0.75);
  z-index: 10;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.cross {
  position: relative;
  top: -75px;
  bottom: 0;
  left: 0;
  right: 0;
  font-size: 62px; 
  line-height: 100px;
  text-align: center;
  background-color: rgba(255,255,255,0);
  user-select: none;
}

.header {
  font-size: 200%;
  font-weight: bold;
  margin-bottom: 20px;
  }

p {
  margin: 0px;
}

.month {
  width: 260px;
  display: inline-block;
  font-size: 50%;
}

/* dags-selector pil */
.arrow {
  border: solid white;
  border-width: 0 7px 7px 0;
  /* display: inline-block; */
  position: sticky;
  padding: 7px;
  margin-right: 0px;
  margin-left: 0px;
}

/* måneds-selector pil */
.arrow-small {
  border: solid white;
  border-width: 0 5px 5px 0;
  display: inline-block;
  padding: 5px;
}


/* Grå "disabled" pil, når vælgeren skal være inaktiv */
.disabled {
  border: solid rgb(168, 168, 168);
  border-width: 0 7px 7px 0;
  display: inline-block;
  padding: 7px;
  margin-left: 0px;
}

.right {
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}

.left {
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
}

/* Flere / færre datoer knap */
.moreButton {
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0px;
  -webkit-box-shadow: 0px 4px 4px #666666;
  -moz-box-shadow: 0px 4px 4px #666666;
  box-shadow: 0px 10px 10px #666666;
  color: #000000;
  background-color: rgba(255,255,255,0.87);
  width: 350px;
  height: 80px;
  box-sizing: border-box;
  text-decoration: none;
  text-transform: uppercase;
  letter-spacing: -1px;
  align-items: center;
  justify-content: center;
  padding: 20px 10px 10px 10px;
  margin:auto;
  margin-top: 40px;
  margin-bottom: 20px;
  text-align: center;
  font-size: 250%;
}

/* Datovælger når viewport er mindre end 960 px */
@media (max-width: 959px) {
  /* Kolonner til brug ved mobil visning */
  .c-left {
    float: left;
    width: 50px;
    padding-top: 30vh;
  }

  .c-middle {
    display: inline-block;
    width: 400px;
  }

  .c-right {
    float: right;
    width: 50px;
    padding-top: 30vh;
  }

  .right {
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    margin-left: -25px;
  }

  .left {
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
    margin-right: -25px;
  }

  .cross {
    font-size: 52px; 
    line-height: 70px;
    top: 0px;
    transform: scale(0.8);
  }

  .cross {
    position: absolute;
    top: 20;
    bottom: 0;
    left: 0;
    right: 0;
    font-size: 62px; 
    line-height: 100px;
    text-align: center;
    background-color: rgba(255,255,255,0.75);
    user-select: none;
  }

  .disabledReason {
    font-size: 50%;
    top: 35px;
    left: 0px;
  }

}


/* Datovælger når viewport er mindre end 600 px */
@media (max-width: 600px) {
  /* Kolonner til brug ved mobil visning */
  .c-left {
    float: left;
    width: 32px;
    padding-top: 15vh;
  }

  .c-middle {
    display: inline-block;
    width: 250px;
  }

  .c-right {
    float: right;
    width: 32px;
    padding-top: 15vh;
  }

  .right {
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
    margin-left: -20px;
  }

  .left {
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
    margin-right: -25px;
  }

  div .dateButton {
    box-shadow: 0px 5px 5px #666666;
    width: 70px;
    height: 70px;
    padding: 10px 5px 5px 5px;
    margin-top: 5px;
    margin-left: 5px;
    margin-right: 5px;
    margin-bottom: 10px;
  }

  div .dateButtonTextHeader {
    font-size: 70%;
  }

  div .dateButtonTextContent {
    font-size: 155%;
  }

  div .dateButtonTextContentToday {
    font-size: 135%;
  }

}



</style>
